import React from "react";
import { Link } from "react-router-dom";

const MakeDifference = ({ title1, title2, description }) => {
	return (
		<div className='max-w-[1440px] w-[90%] mx-auto flex lg:flex-row flex-col lg:justify-between justify-center items-center sm:gap-y-8 gap-y-4 md:py-16'>
			<h1 className='text-4xl/[44px] lg:text-[64px]/[76px] tracking-[-0.5px] font-medium text-[#11112D] lg:text-left text-center'>
				{title1}
				<br className='xl:flex hidden' />
				{title2}
			</h1>
			<div className='sm:space-y-10 space-y-5 max-w-[627px]'>
				<p className='w-full lg:text-left text-center lg:text-2xl/10 text-sm/6 text-[#11112D] font-light'>
					{description}
				</p>
				<div className='flex items-center sm:gap-6 gap-[14px] xl:justify-start justify-center'>
					{/* Link to /donate */}
					<Link
						to='/donate'
						className='text-black  bg-[#22E27F] border-[#22E27F] border sm:px-9 px-5 sm:py-5 py-3 rounded-full w-fit font-medium sm:text-lg/7 text-[11px]/4'>
						Start Donating Now
					</Link>
					{/* Link to /volunteer */}
					<Link
						to='/volunteer'
						className='text-[#22E27F] bg-white sm:px-9 px-5 sm:py-5 py-3 rounded-full border-[#22E27F] border w-fit font-medium sm:text-lg/7 text-[11px]/4'>
						Become a Volunteer
					</Link>
				</div>
			</div>
		</div>
	);
};

export default MakeDifference;
